export default function toArray(arrayLike: any): any[] {
	return Array.prototype.slice.call(arrayLike)
}
